import { Epic, ofType } from 'redux-observable';
import { ignoreElements, tap } from 'rxjs/operators';

import { MemberPayload } from '../../../types/members.types';
import { getArtifactVersion } from '../../../utils/artifact-version/artifact-version';
import { errorLogger } from '../../../utils/error-logger/error-logger';
import { NAMES } from '../../actions/login';
import { Action } from '../../redux.types';

export const sessionEpic: Epic<Action, any> = (action$) => {
  return action$.pipe(
    ofType(NAMES.CHECK_SESSION_SUCCESS),
    tap((data: Action<MemberPayload>) => {
      errorLogger.setLoggingContext({
        userId: data.payload.id,
        artifactVersion: getArtifactVersion(),
      });
    }),
    ignoreElements(),
  );
};
